import React from 'react'
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import "../../assets/css/--component-agent.css"
import { useNavigate } from 'react-router-dom'
import Image from '../../components/Image'
import campaignSuccess from "../../assets/images/campaign-success.png"

const Thankyou = () => {
    return (
        <div className='d-flex align-items-center justify-content-center vh-100'>
            <div>
                <Row>
                    <Col md={12} className='text-center'>
                        <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                        <h1>Payment Confirmation</h1>
                        <h4>Transaction Processed Successfully</h4>
                        <p className='fs-16'>Your subscription payment was successful. We appreciate your purchase!</p>
                    </Col>
                </Row>
                <Row className="text-center mt-3">
                    <Col>
                        <Link to={"/billing"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Go back to Wiserep</Link>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Thankyou
